var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LegendCtrl",on:{"click":_vm.handleClick}},[_vm._v(" Legenda ")])}
var staticRenderFns = []

export { render, staticRenderFns }